function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceDnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.41,11.07a.88.88,0,0,1,.88.82h0v1.94a.88.88,0,0,1-.82.88h-1a.89.89,0,0,1-.83-.88h0v-1.9a1.07,1.07,0,0,1,.56-.88.09.09,0,0,0,.09-.09h0a5.76,5.76,0,0,0-5.5-4.1A5.92,5.92,0,0,0,8.23,11c0,.2.09.09.28.2a.75.75,0,0,1,.45.76v1.91a.89.89,0,0,1-.64.88c-.09.1,0,.19,0,.29a5.73,5.73,0,0,0,3.75,3.72c.46.1.18-.48,1-.48h1.54a.65.65,0,0,1,.64.67h0v.76a.65.65,0,0,1-.63.67H13.07a.69.69,0,0,1-.76-.47.49.49,0,0,0-.46-.29,7.08,7.08,0,0,1-4.41-4.41c-.09-.19-.09-.38-.36-.38L7,14.71a.83.83,0,0,1-.77-.88v-1.9a.94.94,0,0,1,.89-.88c.08,0,.26,0,.26-.19A6.77,6.77,0,0,1,13.68,6,6.54,6.54,0,0,1,20,10.86.46.46,0,0,0,20.41,11.07Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.63,17.88A4.63,4.63,0,0,0,18,13v-.09a4.48,4.48,0,0,0-4.35-4.61h-.11A4.47,4.47,0,0,0,9.27,13h0A4.64,4.64,0,0,0,13.63,17.88Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.39,21.16a3.49,3.49,0,0,1-1.28.23h-.68a3.39,3.39,0,0,1-2.17-.71,5.37,5.37,0,0,0-1-.84,1.77,1.77,0,0,0-2.11.36A16.15,16.15,0,0,0,6,23.57l-.36.77c-.15.33-.31.88-.09,1.19A1.8,1.8,0,0,0,6.86,26H18.71A5.63,5.63,0,0,1,15.39,21.16Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.59,15.9a5,5,0,1,0,5,5h0a5,5,0,0,0-5-5Zm2.86,6.17H18.72V19.75h5.73Z",
    style: {
      fill: "#e9001c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceDnd);
export default __webpack_public_path__ + "static/media/presence-dnd.71ab23c7.svg";
export { ForwardRef as ReactComponent };